module.exports = require('./lib');



//////////////////
// WEBPACK FOOTER
// ./~/deepcopy/index.js
// module id = 4
// module chunks = 1